import { EditEmailDomainsComponent } from './edit-email-domains/edit-email-domains.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';

const routes: Routes = [
    {
        path: 'edit',
        component: EditEmailDomainsComponent,
        canActivate: [AuthGuard] //, RouteGuardService
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class EmailDomainsRoutingModule {}
